// ============================================
// GET QUOTE MODAL - PRODUCTION READY
// ============================================

document.addEventListener('DOMContentLoaded', function() {
    'use strict';
    
    // ============================================
    // CONFIGURATION
    // ============================================
    const CONFIG = {
        ENDPOINT: 'https://spellwebdesign.com/clients/unitedlift/api/send-quote.php',
        RATE_LIMIT_WAIT: 60000, // 60 seconds between submissions
        SUCCESS_DELAY: 4000, // 4 seconds before closing
        MIN_TIME_SPENT: 3, // Minimum seconds to fill form
    };
    
    // ============================================
    // DOM REFERENCES
    // ============================================
    const modal = document.getElementById('quoteModal');
    const closeBtn = document.querySelector('.close-modal');
    const quoteForm = document.getElementById('quoteForm');
    const getQuoteBtns = document.querySelectorAll('.get-quote-btn');
    const successMessage = document.querySelector('.quote-success');
    const errorMessageDiv = document.querySelector('.quote-error') || createErrorElement();
    
    // State variables
    let isSubmitting = false;
    let formStartTime = null;
    let lastSubmitTime = 0;
    
    // ============================================
    // CREATE ERROR ELEMENT (if not exists)
    // ============================================
    function createErrorElement() {
        const div = document.createElement('div');
        div.className = 'quote-error';
        div.style.display = 'none';
        div.innerHTML = `
            <div class="error-icon"><i class="fas fa-exclamation-circle"></i></div>
            <h3 style="color: #dc3545;">Oops! Something went wrong</h3>
            <p id="errorText">There was an error sending your request. Please try again.</p>
            <button class="btn btn-error-close" onclick="this.parentElement.style.display='none'; document.querySelector('.submit-quote').style.display='flex'; document.querySelector('.submit-quote').disabled = false;">Try Again</button>
        `;
        if (quoteForm) {
            quoteForm.parentNode.insertBefore(div, quoteForm.nextSibling);
        }
        return div;
    }
    
    // ============================================
    // HELPER FUNCTIONS
    // ============================================
    function showError(message) {
        const errorText = document.getElementById('errorText');
        if (errorText) {
            errorText.textContent = message || 'There was an error sending your request. Please try again.';
        }
        if (errorMessageDiv) {
            errorMessageDiv.style.display = 'block';
            errorMessageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
    
    function hideMessages() {
        if (successMessage) successMessage.style.display = 'none';
        if (errorMessageDiv) errorMessageDiv.style.display = 'none';
    }
    
    function resetFormState() {
        const submitBtn = quoteForm ? quoteForm.querySelector('.submit-quote') : null;
        if (submitBtn) {
            submitBtn.style.display = 'flex';
            submitBtn.disabled = false;
            submitBtn.innerHTML = '<i class="fas fa-paper-plane"></i> Get Quote';
        }
        hideMessages();
        if (quoteForm) {
            quoteForm.style.display = 'block';
        }
        isSubmitting = false;
    }
    
    function closeModal() {
        if (modal) {
            modal.style.display = 'none';
            document.body.style.overflow = 'auto';
        }
        resetFormState();
        formStartTime = null;
    }
    
    // ============================================
    // MODAL OPEN HANDLER
    // ============================================
    getQuoteBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            
            const productTitle = this.getAttribute('data-product-title') || '';
            const productId = this.getAttribute('data-product-id') || '';
            const collectionName = this.getAttribute('data-collection-name') || '';
            
            // Set form values
            const titleField = document.getElementById('productTitle');
            const idField = document.getElementById('productId');
            const collectionField = document.getElementById('collectionName');
            const displayField = modal ? modal.querySelector('.modal-product-title') : null;
            
            if (titleField) titleField.value = productTitle;
            if (idField) idField.value = productId;
            if (collectionField) collectionField.value = collectionName;
            if (displayField) displayField.textContent = productTitle;
            
            // Reset form
            resetFormState();
            if (quoteForm) quoteForm.reset();
            
            // Track timing
            formStartTime = Date.now();
            
            // Show modal
            if (modal) {
                modal.style.display = 'block';
                document.body.style.overflow = 'hidden';
            }
            
            // Focus first field
            setTimeout(function() {
                const firstName = document.getElementById('firstName');
                if (firstName) firstName.focus();
            }, 300);
        });
    });
    
    // ============================================
    // CLOSE MODAL HANDLERS
    // ============================================
    if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
    }
    
    if (modal) {
        modal.addEventListener('click', function(e) {
            if (e.target === modal) {
                closeModal();
            }
        });
    }
    
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal && modal.style.display === 'block') {
            closeModal();
        }
    });
    
    // ============================================
    // FORM SUBMISSION
    // ============================================
    if (quoteForm) {
        quoteForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // ============================================
            // VALIDATION
            // ============================================
            
            // 1. Rate limiting - prevent double submissions
            if (isSubmitting) {
                console.log('⏳ Already submitting, please wait...');
                return;
            }
            
            // 2. Rate limiting - prevent spam submissions
            const now = Date.now();
            if (now - lastSubmitTime < CONFIG.RATE_LIMIT_WAIT) {
                const waitSeconds = Math.ceil((CONFIG.RATE_LIMIT_WAIT - (now - lastSubmitTime)) / 1000);
                showError('Please wait ' + waitSeconds + ' seconds before submitting again.');
                return;
            }
            
            // 3. Honeypot - hidden field bots fill
            const website = document.getElementById('website')?.value || '';
            if (website) {
                console.log('🛡️ Honeypot triggered - bot detected');
                showError('Bot detected. Please try again.');
                return;
            }
            
            // 4. Time check - form filled too fast
            if (formStartTime) {
                const timeTaken = (now - formStartTime) / 1000;
                console.log('⏱️ Time taken:', timeTaken.toFixed(1), 'seconds');
                if (timeTaken < CONFIG.MIN_TIME_SPENT) {
                    showError('Please take your time to fill out the form properly.');
                    return;
                }
            }
            
            // 5. Get form values
            const firstName = document.getElementById('firstName')?.value?.trim() || '';
            const lastName = document.getElementById('lastName')?.value?.trim() || '';
            const company = document.getElementById('company')?.value?.trim() || '';
            const zipCode = document.getElementById('zipCode')?.value?.trim() || '';
            const email = document.getElementById('email')?.value?.trim() || '';
            const phone = document.getElementById('phone')?.value?.trim() || '';
            const productTitle = document.getElementById('productTitle')?.value || '';
            const collectionName = document.getElementById('collectionName')?.value || '';
            
            // 6. Required fields validation
            if (!firstName || !lastName || !zipCode || !email || !phone) {
                showError('Please fill in all required fields (First Name, Last Name, Zip Code, Email, Phone).');
                return;
            }
            
            // 7. Email format validation
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(email)) {
                showError('Please enter a valid email address.');
                return;
            }
            
            // ============================================
            // SUBMIT
            // ============================================
            
            isSubmitting = true;
            lastSubmitTime = Date.now();
            
            const submitBtn = quoteForm.querySelector('.submit-quote');
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Sending...';
            }
            
            hideMessages();
            
            // Build form data
            const formData = new FormData();
            formData.append('firstName', firstName);
            formData.append('lastName', lastName);
            formData.append('company', company || ''); // Optional field
            formData.append('zipCode', zipCode);
            formData.append('email', email);
            formData.append('phone', phone);
            formData.append('productTitle', productTitle);
            formData.append('collectionName', collectionName);
            formData.append('timeTaken', Math.round((Date.now() - (formStartTime || Date.now())) / 1000));
            formData.append('website', website);
            
            console.log('📧 Sending quote request...');
            console.log('📋 Product:', productTitle);
            console.log('👤 From:', firstName, lastName);
            
            // Send request
            fetch(CONFIG.ENDPOINT, {
                method: 'POST',
                body: formData
            })
            .then(function(response) {
                return response.json().then(function(data) {
                    if (!response.ok) {
                        throw new Error(data.error || 'Server error (HTTP ' + response.status + ')');
                    }
                    return data;
                });
            })
            .then(function(data) {
                console.log('✅ Success:', data);
                
                // Show success
                if (submitBtn) submitBtn.style.display = 'none';
                if (successMessage) successMessage.style.display = 'block';
                if (quoteForm) quoteForm.style.display = 'none';
                
                // Auto-close after delay
                setTimeout(function() {
                    closeModal();
                }, CONFIG.SUCCESS_DELAY);
            })
            .catch(function(error) {
                console.error('❌ Error:', error);
                
                let userMessage = 'Unable to send your request. Please try again.';
                if (error.message.includes('429')) {
                    userMessage = 'Too many requests. Please wait a moment and try again.';
                } else if (error.message.includes('rate')) {
                    userMessage = 'Please wait a moment before trying again.';
                } else if (error.message.includes('network')) {
                    userMessage = 'Network error. Please check your connection and try again.';
                }
                
                showError(userMessage);
                
                // Reset button
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = '<i class="fas fa-paper-plane"></i> Get Quote';
                }
                isSubmitting = false;
            });
        });
    }
    
    console.log('✅ Get Quote Modal initialized successfully');
});